import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import InputText from "../components/Form/InputText";
import { MultipleFileUploadField } from "../components/FileUpload/MultipleFileUploadField";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { COMPENSATION_CAR } from "./Compensation";

export default function CompensationForCar() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    // Reset specific fields if the selected compensation is not COMPENSATION_CAR
    useEffect(() => {
        if (formData.compensation === COMPENSATION_CAR) {
            setFormData((prev) => ({
                ...prev,
                taxireceipt: []
            }));
        }
    }, [formData.compensation, setFormData]);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/hur-vill-du-ha-ersattning");

                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    cartravelfrom: Yup.string().required(
                        "Vänligen fyll i vart du åkte från"
                    ),
                    cartravelto: Yup.string().required(
                        "Vänligen fyll i vart du åkte till"
                    ),
                    distance: Yup.string()
                        .required("Vänligen fyll i hur långt du åkte")
                        .max(10, "Antalet tecken får vara högst 10"),
                    carlicenceplate: Yup.string().required(
                        "Vänligen fyll din bils registreringsnummer"
                    ),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs md:mb-4">
                                <Progressbar percentage={"60"} />
                            </div>
                        </div>
                        <Form noValidate>

                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="">
                                    Resa med bil
                                </h2>

                                <p>
                                    Fyll i uppgifterna om din resa. Har du behövt betala för parkering bifogar du kvitto för det (bild på kvittot räcker).
                                    Du kan få ersättning upp till 1/40-del av gällande prisbasbelopp.
                                </p>
                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="cartravelfrom"
                                    label={
                                        <>
                                            Jag åkte från <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="text"
                                    autocomplete={"off"}
                                />

                                <InputText
                                    name="cartravelto"
                                    label={
                                        <>
                                            Jag åkte till <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="text"
                                    autocomplete={"off"}
                                />

                                <InputText
                                    name="distance"
                                    label={
                                        <>
                                            Antal mil <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    numbersAndDecimalsOnly
                                    autocomplete={"off"}
                                />

                                <InputText
                                    name="carlicenceplate"
                                    label={
                                        <>
                                            Registreringsnummer <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="text"
                                    autocomplete={"off"}
                                    upperCase
                                />

                                <MultipleFileUploadField
                                    currentFiles={values.carexpenses}
                                    multiple={true}
                                    type="Filer"
                                    label="Bifoga underlag för övriga kostnader"
                                    inputId="carexpenses"
                                    inputName="carexpenses"
                                />
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
